/**
 * @module ajaxAPI/cart
 *
 * @description
 * Общие методы для работы с Ajax-товарами
 */

import _getNodeFromTemplate from '@/ui/ui_ajax-products/methods/getNodeFromTemplate';
import _getFieldNodes from '@/ui/ui_ajax-products/methods/getFieldNodes';
import _toggleLoadingState from '@/ui/ui_ajax-products/methods/toggleLoadingState';
import _checkIfHasManyProductVariants from '@/ui/ui_ajax-products/methods/checkIfHasManyProductVariants';
import _checkIfProductHasManyPrices from '@/ui/ui_ajax-products/methods/checkIfProductHasManyPrices';
import _imageUrlForPictureSource from '@/ui/ui_ajax-products/methods/imageUrlForPictureSource';
import _renderLabel from '@/ui/ui_ajax-products/methods/renderLabel';
import _createVariantsSelector from '@/ui/ui_ajax-products/methods/createVariantsSelector';

export default {
  _getNodeFromTemplate,
  _getFieldNodes,
  _toggleLoadingState,
  _checkIfHasManyProductVariants,
  _checkIfProductHasManyPrices,
  _imageUrlForPictureSource,
  _renderLabel,
  _createVariantsSelector,
};
